import React from 'react'
import styles from './PageTabs.css'
import newStyles from './PageTabsNew.css'

const PageTabs = ({ children, useNewStyles = false, ...restProps }) => {
  const currentStyles = useNewStyles ? newStyles : styles
  return (
    <div className={currentStyles.pageTabs} {...restProps}>
      {children}
    </div>
  )
}
export default PageTabs



// WEBPACK FOOTER //
// ./src/legacy/components/PageTabs/PageTabs.jsx